module.exports = __webpack_public_path__ + "media/shoot.fe3f5c09.ogg";